import React, { FC } from 'react';

import { Theme } from '@mui/material';
import { useTheme } from '@mui/styles';
import {
  LinearProgressProps as MuiLinearProgressProps
} from "@mui/material";

import {LinearProgressProps} from '../types';
/* styled */
import { StyledLinearProgress } from './styled';


export const LinearProgress: FC<LinearProgressProps> = (props) => {
  const theme: Theme = useTheme();
  return <StyledLinearProgress
    color={props.color}
    height={props.height}
    {...props}
  />;
};
